<template>
  <div>
    <h3 class="lead mb-3">Select what region you would like this site backed up to.</h3>
    <c-select
      style="width: 300px"
      :value="defaultAwsRegionValue"
      placeholder="Select region"
      :options="awsRegions"
      @update:value="handleRegionUpdate"
    >
      <template #append>
        <c-button color="primary" @click="setRegion">
          <c-spinner v-if="saving" color="success" size="sm" />
          <span v-else>Set region</span>
        </c-button>
      </template>
    </c-select>
  </div>
</template>

<script>
import _ from 'lodash';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'EditSiteBackupSettings',
  props: {
    site: Object,
  },
  data() {
    return {
      newRegion: null,
      error: null,
      saving: false,
      showCancelButton: false,
      data: {
        name: null,
        siteAddress: null,
      },
    };
  },

  computed: {
    defaultAwsRegionValue() {
      return (
        _.get(this.site, 'backupOpts.s3Region')
        || _.get(this.$store, 'state.app.authenticatedUser.organisation.backup.defaultS3Region')
      );
    },
    awsRegions() {
      return this.$store.state.app.awsRegions.map((region) => ({
        value: region.region,
        label: region.name,
      }));
    },
  },

  mounted() {
    this.siteId = this.$route.params.siteId;
  },

  methods: {
    handleRegionUpdate(data) {
      this.newRegion = data;
    },
    setRegion() {
      if (!this.newRegion) {
        return;
      }
      const data = {
        siteId: this.siteId,
        awsRegion: this.newRegion,
      };
      this.saving = true;
      this.$http
        .post(buildEndpoint('site/backup/aws-region/update'), data)
        .then((response) => {
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Back up region updated successfully',
            });
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error updating site backup region',
            });
          }
        })
        .catch((error) => {
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
